import React from 'react';
import { Icon, Menu, AppLocaleProvider, Sidebar } from 'sd-ui-components';
import { Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import history from '../../history';
import { useOidc } from '@axa-fr/react-oidc';

const { FormattedMessage } = AppLocaleProvider;

@inject('ConfigStore')
@inject('AuthStore')
@observer
class MenuBar extends React.Component {
  logout = () => {
    const { isAuthenticated, logout } = useOidc();
    if (isAuthenticated) {
      logout('/');
      this.props.AuthStore.removeStorageForLogout();
    } else {
      this.props.AuthStore.logout();
    }
  };

  changePassword = () => {
    const { isAuthenticated } = useOidc();
    if (isAuthenticated) {
      this.props.AuthStore.changePassword();
    } else {
      history.push('/changePassword');
    }
  };
  render() {
    return (
      <Sidebar
        isOpen={this.props.isOpen}
        onStateChange={this.props.onStateChange}
      >
        <Menu theme="dark" mode="inline" className="primary-navigation">
          <Menu.Item key="changePassword" className="no-menu-header">
            <Icon icon="lock" size={18} className="anticon" />
            <span>
              <Link
                to="#"
                className="menuLink"
                onClick={this.changePassword}
                data-automation-id="sd-ui-driver-manage-change-password"
              >
                <FormattedMessage
                  id="App.MenuBar.ChangePassword"
                  defaultMessage="Change password"
                />
              </Link>
            </span>
          </Menu.Item>
          <Menu.Item key="logout">
            <Icon icon="exit" size={18} className="anticon" />
            <span>
              <Link
                to="#"
                onClick={this.logout}
                data-automation-id="sd-ui-driver-manage-logout-button"
              >
                <FormattedMessage
                  id="App.MenuBar.Logout"
                  defaultMessage="Logout"
                />
              </Link>
            </span>
          </Menu.Item>
        </Menu>
      </Sidebar>
    );
  }
}

export default MenuBar;



// WEBPACK FOOTER //
// ./src/containers/AppLayout/MenuBar.jsx